import list from './list'
import show from './show'
import edit from './edit'
import create from './create'

const adminConfig = { list, create, edit, show };

export default adminConfig;

